import { FC } from "react";
import { SignUpWiget } from "../../widgets/sign-up/SignUp";

interface Props {
  onSignUp: () => void;
  setMaxStep: (num: number) => void;
}

export const SignUpPage: FC<Props> = ({ onSignUp, setMaxStep }) => {
  return <SignUpWiget onSignUp={onSignUp} setMaxStep={setMaxStep} />;
};
